import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { CategoryButtons } from "./categoryButtons";
import { useCategory } from "./categoryContext";
import classNames from "classnames";
import * as c from "./categoryFilterList.module.scss";

const CategoryFilterList = ({ className }) => {
  const { blog } = useStaticQuery(
    graphql`
      query {
        blog: allMangomintBlogPostCategory {
          categories: nodes {
            id
            name
            slug
          }
        }
      }
    `
  );

  const { defaultCategory, isSelectedCategory, setSelectedCategory } = useCategory();
  const { Button } = CategoryButtons;

  return (
    <CategoryButtons className={classNames(className, c.buttons)}>
      <Button
        label={defaultCategory.name}
        selected={isSelectedCategory(defaultCategory)}
        onClick={() => setSelectedCategory(defaultCategory)}
      />

      {blog.categories.map((category) => (
        <Button
          label={category.name}
          key={category.id}
          selected={isSelectedCategory(category)}
          onClick={() => setSelectedCategory(category)}
        />
      ))}
    </CategoryButtons>
  );
};

export { CategoryFilterList };
